import { client } from '../../../../../actions';
import { authHeader } from '../../../../../helpers/auth-header';

export const deleteAdminInfoField = async ({ companyId, fieldId }) => {
  const url = `/Admin/company/${companyId}/item/${fieldId}`;

  const response = await client.delete(url, {
    headers: authHeader(),
  });

  return response.data;
};
